import { useState, useEffect } from 'react'
import { getLang, type Lang } from '@/lib/i18n'

export function useLang(): Lang {
  const [lang, setLang] = useState(getLang())
  useEffect(() => {
    const handler = () => setLang(getLang())
    window.addEventListener('langchange', handler)
    return () => window.removeEventListener('langchange', handler)
  }, [])
  return lang
}
